import PropTypes from 'prop-types';
import React from 'react';
import { kebabCase } from 'lodash';
const ControlSwitchControl = _ref => {
  let control = _ref.control,
    children = _ref.children,
    onClick = _ref.onClick;
  const handleClick = () => onClick(control);
  const className = "t-csc-".concat(kebabCase(control.name));
  return /*#__PURE__*/React.createElement("div", {
    role: "link",
    tabIndex: 0,
    className: "control-switch-control t-csc-control-switch-control ".concat(className),
    onKeyPress: handleClick,
    onClick: handleClick
  }, children);
};
ControlSwitchControl.propTypes = {
  control: PropTypes.shape({
    id: PropTypes.string,
    control: PropTypes.node,
    name: PropTypes.string
  }).isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
};
export default ControlSwitchControl;